import { useSelector } from "react-redux";

const usePurchasing = (landId) => {
  const isPurchasing = useSelector((state) => {
    if (landId == null) return false;

    const pendings = state.transactions.pending;
    return pendings.find((tx) => tx.metadata.landId === landId) != null;
  });

  const isPurchaseHappened = useSelector((state) => {
    if (landId == null) return false;

    const mined = state.transactions.mined;
    return mined.find((tx) => tx.metadata.landId === landId) != null;
  });

  return [isPurchasing, isPurchaseHappened];
};

export default usePurchasing;
